export default "__VITE_ASSET__CEC6loE0__"